<image-tile
  [checked]="discoverFilter.active"
  class="hover-opacity"
  [disabled]="disabled"
  [imgUrl]="imageUrl"
  [altText]="altText"
  (click)="onFilterClick()"
>
</image-tile>
